const getAuthUrl = (): string => {
  switch (import.meta.env.VITE_ENVIRONMENT) {
    case 'DEV':
      return 'https://main.betzone.co.uk/auth';
    case 'STG':
      return 'https://main.betzone.co.uk/auth';
    case 'PRODUCTION':
      return 'https://betzone.co.uk/auth';
    default:
      console.warn(`Unknown environment: ${import.meta.env.VITE_ENVIRONMENT}. Defaulting to development auth URL.`);

      return 'https://main.betzone.co.uk/auth';
  }
};

const realm = 'betzone_uk';

export const baseDomain = 'betzone.co.uk';

export const config = {
  realm: realm,
  authUrl: getAuthUrl(),
  clientId: 'web-betzone_uk',
  tenantId: 'betzone_uk',
};
